window.PageForm = (function () {

    var listingModel = {};

    var pageId = (location.pathname.match(/([\d]+)/g) ? location.pathname.match(/([\d]+)/g) : '');

    var sitesPageData = {
        page_id: 0,
        template_id: 1,
        sps_domain: '',
        page_domain: '',
        domain_id: '',
        page_slug: '',
        mls_id: '',
        org_id: ''
    };

    function init(callback){
        store.getInit(App.init.bind(App));
    }

    function listingIndexFormat(json) {
        if (json && json.listings) {
            json.listings.forEach(function(val) {
                val['sq_ft'] = numeral(val.sq_ft).format('0,0');
                val['bath_count'] = numeral(val.bath_count).format('0,0');
                val['list_price'] = numeral(val.list_price).format('0,0');
                val['image'] = encodeURIComponent(val.image.replace('https://'+sitesPageData.util_domain+'tmb/index.php?src=', ''));
            });

            return json;
        }
    }

    var store = {

        getInit: function(callback) {
            $.ajax({
                url: '/site-page/form-json/' + pageId + '?preview=1',
                type: 'GET',
                success: function (json, txt, xhr) {
                    if (json.page) {
                        sitesPageData['page_id'] = json.page.id;
                        sitesPageData['template_id'] = json.page.template_id;
                        sitesPageData['mls_system_id'] = json.page.mls_system_id;
                        sitesPageData['listings_mls_id'] = json.page.listings_mls_id;
                    }
                    sitesPageData['sps_domain'] = json.sps_domain;
                    sitesPageData['page_domain'] = json.page_domain;
                    sitesPageData['page_slug'] = json.page_slug;
                    sitesPageData['util_domain'] = json.util_domain;
                    sitesPageData['domain_id'] = json.domain_id;
                    sitesPageData['mls_id'] = json.mls_id;
                    sitesPageData['org_id'] = json.org_id;

                    callback();
                }
            }).done(function(){
                App.updatePublishLink();
            });
        },

        getListings: function (params, callback) {
            let mls_id = 0;
            //if searching by comarketing partner and they dont have an mls association then use listhub
            if(params.agent_id) {
                mls_id = $('#js-agent-id option:selected').data('agent-mls-id');
                if (!mls_id) {
                    mls_id = 18;
                }
            }

            if(mls_id) {
                params.mls_id = mls_id;
            }

            if ($('.js-listing-status').length) {
                params.status = $('.js-listing-status').val();
            }

            $.ajax({
                url: '/listings/search',
                type: 'GET',
                data: params,
                success: function (json, txt, xhr) {
                    var status = parseInt(json.status);

                    if (xhr.status == 200 && status !== 0 && typeof callback === 'function') {
                        listingIndexFormat(json);
                        callback(json);
                    } else {
                        $('.tidx_agent-search-results').html(buildEmptyPanel('No Listings Found', 'Try searching by MLS# or agent name.', 'fa-home'));
                    }
                }
            });
        },

        getListing: function (listings_mls_id, callback) {
            $.ajax({
                url: '/listings/details?listings_mls_id=' + listings_mls_id,
                success: function (json, txt, xhr) {
                    var status = parseInt(json.status);

                    if (xhr.status == 200 && status !== 0) {
                        listingModel = json;

                        if (typeof callback === "function") {
                            callback();
                        }
                    }
                }
            });
        },

        getTemplateOptions: function(template, callback) {
            $.ajax({
                url: '/site-page/content-parts?preview=1',
                data: {
                    template: template,
                    page_id: sitesPageData.page_id,
                },
                type: 'POST',
                success: function(json, txt, xhr) {
                    var status = parseInt(json.status);

                    if(xhr.status == 200 && status !== 0 && typeof callback === 'function') {
                        callback(json);
                    }
                }
            });
        },


        // TODO: after saving update the page id, else it will think it a duplicate site
        saveSite: function(callback) {
            App.setPageAddress();
            App.shouldShowSocialShare();
            var $pageAddressLink = $('#js-page-slug-field');
            var pageAddressLinkIsValid = $pageAddressLink.parsley('isValid').validationResult;
            var $pageName = $(".page-name").val();
            var $value = $("[data-system-name=street_address]").val();

            if($pageName == '' || $pageName == 'Main St'){
               $(".page-name").val($value);
            }

            if (pageAddressLinkIsValid) {
                if (App.checkForHTMLTags()) {
                    return false;
                }

                const metaDescSelector = ":input[name='contents[meta_desc]']";
                const pageTitleSelector = ":input[name='contents[page_title]']";
                $(metaDescSelector).val(App.returnSafeValue($(metaDescSelector).val()));
                $(pageTitleSelector).val(App.returnSafeValue($(pageTitleSelector).val()));

                $.ajax({
                    url: '/site-page/form/' + sitesPageData.page_id + '?preview=1',
                    data: $('#js-customize-site-form').serialize(),
                    type: 'POST',
                    success: function(json, txt, xhr) {
                        if(xhr.status == 200 && typeof callback === 'function') {
                            if (sitesPageData.page_id == 0 && json.id != 0 && json.status == 1) {
                                location.replace(location.origin + '/site-page/form/' + json.id + '?preview-tab=1&preview=1');
                            }

                            sitesPageData.page_id = json.id;

                            if (typeof callback === 'function') {
                                callback(json);
                            }
                        } else {
                            confirmModal('Website could not be saved at this time.');
                        }

                        store.getInit(function(){ });
                    }
                });
            }
        }
    };

    var App = {
        init: function() {
            var self = this;
            var agentDom = $('#js-agent-id option:selected');
            var agent_id = agentDom.attr('data-agent-id');

            if(agent_id){
                store.getListings({
                    agent_id: agent_id,
                }, this.renderListings);
            }
            this.getAndbuildTemplateOptions(function() {
                self.shouldGetListingInit();
                self.updatePreview('preview-window');
            });

            this.bindNavbarEvents();
            this.bindformEvents();
            this.preLoadListingFromParameters();
        },

        preLoadListingFromParameters: function() {
            var queryStr = window.location.search.replace("?", "");
            var queryParams = $.deparam(queryStr);

            if (queryParams.mls_number) {
                $('#js-site-mls-number-search').val(queryParams.mls_number);
                store.getListings({
                    state: $('#js-state').val(),
                    mls_number: queryParams.mls_number
                }, App.renderListings);
            }

            if (queryParams.location) {
                $('#js-site-location-search').val(queryParams.location);
                store.getListings({
                    state: $('#js-state').val(),
                    mls_number: queryParams.mls_number
                }, App.renderListings);
            }

            if (queryParams.state) {
                $('#js-state').selectpicker('val', queryParams.state);
            }
        },

        bindListingEvents: function() {
            var self = this;

            $('#js-listings-window').off('click').on('click', '.js-populate-mls-btn', function() {
                self.selectListing(this, function() {
                    store.saveSite(self.validateWebAddress);
                    self.activateTab('preview-tab');
                    self.updatePreview('preview-window');
                });
            });
        },

        shouldGetListingInit: function () {
            var self = this;

            if (sitesPageData.listings_mls_id) {
                store.getListing(sitesPageData.listings_mls_id, function () {
                    self.shouldShowSocialShare();
                    self.activateTab('preview-tab');
                    self.updatePreview('preview-window');
                });
            }
        },

        shouldShowSocialShare: function () {
            var $socialEl = $('[data-system-name="social_share"]');
            // hide social share for movements NY listings
            if (sitesPageData.org_id == 5 && listingModel.listing && listingModel.listing.details.state == 'NY') {
                $socialEl.val(0).closest('.form-group').hide();
            } else {
                $socialEl.closest('.form-group').show();
            }
        },

        validateWebAddress: function(json) {
            var $domainNameInput = $('.js-domain-name-modal-input');
            var domainNameErrorMessage = $domainNameInput.parsley();

            if (domainNameErrorMessage) {
                window.ParsleyUI.removeError(domainNameErrorMessage, "myCustomError");
            }

            switch (json.status) {
                case 1:
                    buildFlashMessage('Site saved.', 'success');
                    $('#domain-name-modal').modal('hide');
                    break;
                case 2:
                    $('#domain-name-modal').modal('show');
                    $domainNameInput.val($('#js-page-slug-field').val());
                    window.ParsleyUI.addError(domainNameErrorMessage, "myCustomError", 'This address is already being used, please try something else.  Page Address Link only allows letters, numbers, and dashes.');
                    break;
                case 3:
                    var max = json.max;
                    confirmModal(`You have reached your limit of ${max} sites saved. Please review your list of active sites to determine whether any should be deactivated, or upgrade your account to add more now.`);
                    break;
                default:
                    confirmModal('Website could not be saved at this time.');
            }
        },

        checkPageSlug: function() {
            var $pageAddressLink = $('#js-page-slug-field').val();

            if ($('#js-domain-select option:selected').attr('data-requires-slug') == 1) {
                if (! $pageAddressLink) {
                    this.setPageAddress();
                }
            }
        },
        returnSafeValue: function (rawValue) {
            const textArea = document.createElement('textarea');
            textArea.innerHTML = rawValue;
            return textArea.value;
        },
        returnHtmlValue: function (rawValue) {
            const textArea = document.createElement('textarea');
            textArea.innerHTML = rawValue;
            return textArea.innerHTML;
        },
        checkForHTMLTags: function () {
            var $page_title = $('input[name="contents[page_title]"]'),
                $top_intro_text = $('input[name="contents[top_intro_text]"]'),
                $street_address = $('input[name="contents[street_address]"]'),
                $city_state = $('input[name="contents[city_state]"]'),
                $sub_address_text = $('input[name="contents[sub_address_text]"]'),
                $details = $('textarea[name="contents[details]"]');

            var $fieldsToCheck = [
                ["Page Title", $page_title],
                ["Top Intro Text", $top_intro_text],
                ["Street Address", $street_address],
                ["City,State", $city_state],
                ["Text Below Address", $sub_address_text],
                ["Remarks & details", $details],
            ];
            const htmlTagRe = /<.+?>/g;

            for (let element of $fieldsToCheck) {
                if (element && element.length > 1 && element[1] && element[1].val()) {
                    if (element[1].val().match(htmlTagRe)) {
                        buildFlashMessage(`${element[0]} cannot contain html tags.`, 'error');
                        return true;
                    }
                }

            }

            return false;
        },

        setPageAddress: function () {
            var $pageAddressLink = $('#js-page-slug-field').val();
            var $pageTitle = $('input[data-system-name="page_title"]').val();
            var $selectedWebsiteDomain = $('#js-domain-select option:selected');

            if (! $pageAddressLink && $selectedWebsiteDomain.attr('data-requires-slug') === '1') {
                $('#js-page-slug-field').val(this.formatUrl($pageTitle));
                $('.js-domain-name-modal-input').val(this.formatUrl($pageTitle));
            }
        },

        formatUrl: function(jqueryValue) {
            return jqueryValue.trim()
                   .toLowerCase()
                   .replace(/\s+/g, '-')
                   .replace(/[^0-9a-z-]/g, "");
        },

        updatePublishLink: function(){
            var url = sitesPageData.domain_id == '0' ? '//' + sitesPageData.sps_domain  + sitesPageData.page_slug : '//' + sitesPageData.page_domain + "/" + sitesPageData.page_slug;

            $(".js-publish-btn").attr("href", url);
        },

        updateNameFromModal: function () {
            var $modalVal = $('.js-domain-name-modal-input').val();
            $('#js-page-slug-field').val($modalVal);
            store.saveSite(this.validateWebAddress);
        },

        renderListings: function (json) {
            var $listingPanel = $('.tidx_agent-search-results');
            var template = Handlebars.compile($('#listings-template').html());

            $listingPanel.html(template(json));
            App.bindListingEvents();
        },

        selectListing: function (searchbtn, callback) {
            var self = this;
            var listingsMlsId = $(searchbtn).attr('data-listings-mls-id');
            var currentMlsNumber = $(searchbtn).attr('data-mls-number');

            if (listingsMlsId) {
                store.getListing(listingsMlsId, function () {
                    self.populateListingFields(listingModel, function () {
                        if (typeof callback === 'function') {
                            callback();
                        }
                    });
                });

                $('#js-site-mls-number').val(currentMlsNumber);
                $('#js-listings-mls-id').val(listingsMlsId);
                $('#media-library-modal').remove();
            }
        },


        populateListingFields: function(json, callback) {
            var inputArr = $('#js-template-fields [data-type-id]');
            var address = json.listing.details.address;

            $(".page-name").val(address);

            inputArr.each(function(i, elem) {
                var $element = $(inputArr[i]);
                var mlsDefault = $element.attr('data-mls-default');

                switch($element.attr('data-type-id')) {
                    case '1':
                        if (mlsDefault.length > 0) {
                            var fields = mlsDefault.split(/[\s,]+/);
                            var finalValue = '';

                            $.each(fields, function (key, field) {
                                finalValue += json.listing.details[field] + ' ';
                                if (!isNaN(parseInt(finalValue)) && isFinite(finalValue) && field != 'year_built') {
                                    finalValue = parseInt(finalValue).toLocaleString();
                                }
                            });

                            $element.val(finalValue.trim());
                        }
                        break;
                    case '2':
                        break;
                    case '3':
                        var template = Handlebars.compile($('#form-gallery-image-template').html());
                        $element.html(template(json.listing));
                        break;
                    case '4':
                        $('#editor-' + $element.attr('data-system-name')).html(json.listing.details[$element.attr('data-mls-default')]);
                        break;
                    case '5':
                        var mls_image_index = $element.attr('data-mls-default').split('-')[1];
                        $element.find('input').val(json.listing.images[mls_image_index]);
                        $element.find('img').attr('src', json.listing.images[mls_image_index]);
                        break;
                }
            });

            if (typeof callback === "function") {
                callback('preview-window');
            }
        },

        getAndbuildTemplateOptions: function (callback) {
            var self = this;

            store.getTemplateOptions($('#js-template-select').val(), function (json) {
                self.buildTemplateOptions(json, function () {
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        },

        buildTemplateOptions: function(json, callback) {
            var $form = $('#js-template-fields');
            var template = Handlebars.compile($('#form-options-template').html());

            $form.html(template(json));

            if (typeof callback === "function") {
                callback();
                $('#js-gallery-gallery_images').sortable();
            }
        },

        addGalleryImage: function() {
            var self = this;
            var json = {
                images: []
            };
            var template = Handlebars.compile($('#form-gallery-image-template').html());

            $().mediaLibrary({
                listings_mls_id: $('#js-listings-mls-id').val(),
                img_id: '#js-field-gallery_images0',
                field_id: '',

                callback:function(image_url){
                    json.images.push(image_url);
                    $('#js-gallery-gallery_images').append(template(json));
                    self.updatePreview();
                    store.saveSite(self.validateWebAddress);
                }
            });

        },

        addImage: function(target) {
            var self = this;
            var targetField = $(target).attr('data-target-field');

            $().mediaLibrary({
                listings_mls_id: $('#js-listings-mls-id').val(),
                img_id: '',
                field_id: '',

                callback:function(image_url){
                    $('img' + targetField).attr('src', image_url);
                    $('input' + targetField).val(image_url);
                    $(target).siblings('.js-remove-image').show();
                    self.updatePreview();
                    store.saveSite(self.validateWebAddress);
                }
            });
        },

        removeImage: function (target) {
            var $this = $(target);
            var image_id = $this.attr('data-image-id');

            $('input.js-image-field-' + image_id).val('');
            $('img.js-image-field-' + image_id).attr('src', '');
            $this.hide();
            this.updatePreview();
        },

        addPartner: function (target) {
            var $selectedOption = $($(target).attr('data-target') + ' select option:selected');

            if (this.validatePartners($selectedOption.val())) {
                var template = Handlebars.compile($('#sort-partner-template').html());
                var json = {
                    user_id: $selectedOption.val(),
                    user_name: $selectedOption.text()
                };

                $('#co-marketers-box').append(template(json));
            }
        },

        validatePartners: function (userId) {
            var el = $('.co-marketer-item input');
            var isUnique = this.validatePartnerUnique(userId, el);
            var status = (el.length < 2 && isUnique) ? true : false;

            if (!isUnique) {
                confirmModal('Duplicate Co-marketers are not allowed.');
            }

            if (el.length === 2) {
                confirmModal('Limit 2 Co-marketers.');
            }

            return status;
        },

        validatePartnerUnique: function (userId, arr) {
            var newArr = $.map(arr, function (value, i) {
                return $(value).val();
            });

            for (var i = 0; i < newArr.length; i++) {
                if (newArr[i] === userId) {
                    return false;
                }
            }
            return true;
        },

        removePartner: function(target) {
            var userId = $(target).attr('data-user-id');
            $('#js-comarketer-'+userId).remove();
        },

        updatePreview: function(target) {
            var pageId = sitesPageData.page_id || 0;

            if (pageId == 0) {
                return;
            }
            if (App.checkForHTMLTags()) {
                return false;
            }

            const metaDescSelector = ":input[name='contents[meta_desc]']";
            const pageTitleSelector = ":input[name='contents[page_title]']";
            $('#js-customize-site-form').attr('target', target);
            $('#js-customize-site-form').attr('action', '//' + sitesPageData.sps_domain + pageId + '?preview=1');
            $('#js-customize-site-form').on('submit', function() {

                $(metaDescSelector).val(App.returnHtmlValue($(metaDescSelector).val()));
                $(pageTitleSelector).val(App.returnHtmlValue($(pageTitleSelector).val()));

                return true;
            })
            $('#js-customize-site-form').trigger('submit');
            $(metaDescSelector).val(App.returnSafeValue($(metaDescSelector).val()));
            $(pageTitleSelector).val(App.returnSafeValue($(pageTitleSelector).val()));
        },

        activateTab: function(tab) {
            $('.nav-pills a[href="#' + tab + '"]').tab('show');
        },

        getListings: function(rel) {
            let state = $('#js-state').val();

            if (state) {
                let params = {
                    state: state,
                    status: $('[name="listing_status"]').val()
                };

                if (window.lastSearchElement) {
                    if (window.lastSearchElement.selector === '#js-site-mls-number-search-btn') {
                        let mlsNumber = $('#js-site-mls-number-search').val();
                        if (mlsNumber) {
                            params.mls_number = mlsNumber;
                        }
                    } else if (window.lastSearchElement.selector === '.js-site-location-search button') {
                        let location = $('#js-site-location-search').val();
                        if (location) {
                            params.location = location;
                        }
                    }
                } else {
                    let queryStr = window.location.search.replace("?", "");
                    let queryParams = $.deparam(queryStr);

                    if (queryParams.mls_number) {
                        params.mls_number = queryParams.mls_number;
                    } else if (queryParams.location) {
                        params.location = queryParams.location;
                    }
                }

                store.getListings(params, rel.renderListings);
            } else {
                confirmModal('Select a state to search');
            }
        },

        bindformEvents: function() {
            var self = this;
            window.lastSearchElement = {
                selector: '.js-site-location-search button',
                event: 'click'
            };

            $('.js-site-location-search button').on('click', function () {
                window.lastSearchElement = {
                    selector: '.js-site-location-search button',
                    event: 'click'
                };
                App.getListings(self);
            });

            $('.js-listing-status').change(function() {
                $(window.lastSearchElement.selector).trigger(window.lastSearchElement.event);
            });

            $('#js-site-mls-number-search-btn').on('click', function () {
                window.lastSearchElement = {
                    selector: '#js-site-mls-number-search-btn',
                    event: 'click'
                };

                store.getListings({
                    state: $('#js-state').val(),
                    mls_number: $('#js-site-mls-number-search').val()
                }, self.renderListings);
            });

            $('#js-agent-id').on('change', function(){
                window.lastSearchElement = {
                    selector: '#js-agent-id',
                    event: 'change'
                };

                var agentDom = $('#js-agent-id option:selected');
                var agent_id = agentDom.attr('data-agent-id');
                if (agent_id) {
                    store.getListings({
                        agent_id: agent_id,
                    }, self.renderListings);
                }
            });

            $('#js-template-select').change(function () {
                var value = $(this).val();

                self.getAndbuildTemplateOptions(function () {
                    if (listingModel.listing) {
                        self.populateListingFields(listingModel, function () {
                            store.saveSite(self.validateWebAddress);
                            self.updatePreview('preview-window');
                        });
                    }
                });
            });

            $('#collapse-settings input[type="radio"][name="website_status"]').change(function() {
                store.saveSite(self.validateWebAddress);
            });

            // Start customize pan form
            $('#collapse-custom').on('change', 'select.form-control', function () {
                self.updatePreview('preview-window');
                store.saveSite(self.validateWebAddress);
            })
            .on('blur', 'input.form-control', function () {
                self.updatePreview('preview-window');
                store.saveSite(self.validateWebAddress);
            })
            .on('blur', 'textarea.form-control', function () {
                self.updatePreview('preview-window');
                store.saveSite(self.validateWebAddress);
            })
            .on('click', '.js-remove-gallery-image', function () {
                $(this).parent().remove();
                self.updatePreview('preview-window');
                store.saveSite(self.validateWebAddress);
            })
            .on('click', '#js-add-gallery-image', function () {
                self.addGalleryImage();
            })
            .on('click', '.js-image-field-btn', function () {
                self.addImage(this);
            })
            .on('click', '.js-remove-image', function () {
                self.removeImage(this);
                store.saveSite(self.validateWebAddress);
            })
            .on('sortupdate', '#js-gallery-gallery_images', function () {
                self.updatePreview('preview-window');
                store.saveSite(self.validateWebAddress);
            });

            $('.js-add-comarketer-btn').on('click', function () {
                self.addPartner(this);
                self.updatePreview('preview-window');
                store.saveSite(self.validateWebAddress);
            });

            $('#co-marketers-box').on('click', '.js-remove-comarketer', function () {
                self.removePartner(this);
                self.updatePreview('preview-window');
                store.saveSite(self.validateWebAddress);
            });

            $('#co-marketers-box').sortable();

            $('#js-customize-site-form').on('sortupdate', '#co-marketers-box', function () {
                self.updatePreview('preview-window');
                store.saveSite(self.validateWebAddress);
            });

            $('#js-submit-customize-form').on('click', function () {
                store.saveSite(self.validateWebAddress);
            });

            $('#js-domain-name-modal-btn').on('click', function () {
                self.updateNameFromModal();
            });

            $('#js-domain-select').on('click', function () {
                self.checkPageSlug();
            });

            $('#collapse-web').on('blur', 'input.form-control', function () {
                store.saveSite(self.validateWebAddress);
            });

            $('#js-domain-select').on('change',function(){
                store.saveSite(self.validateWebAddress);
            });

            $('.js-site-location-search-btn').on('click', function () {
                self.activateTab('listings-tab');
            });

            $('.js-domain-name-modal-input, #js-page-slug-field').on('keyup', function(){
                var $slug = self.formatUrl($(this).val());
                $(this).val($slug);
            });
        },

        bindNavbarEvents: function () {
            var self = this;

            $('#js-update-preview').click(function () {
                self.updatePreview('preview-window');
            });

            $('#js-popup-preview').on('click', function () {
                self.updatePreview('_blank');
            });
        }

    };

    return {
        init: init
    };
})();
